import { useState } from "react";
import { putUpdateNoteURL } from "../utils/ConstantsURL";
import { toastAlert } from "../utils/AlertContext";

export const useUpdateNote = (token) => {
  const [loading, setLoading] = useState(false);

  const updateNote = async (idSintesis, title, synthesis) => {
    setLoading(true);
    try {
      const response = await fetch(putUpdateNoteURL(), {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          id_sintesis: idSintesis,
          titulo: title?.trim(),
          sintesis: synthesis?.trim(),
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Error al actualizar la nota");
      }

      toastAlert("Nota actualizada correctamente", "success");
      return true;
    } catch (error) {
      console.error("Error al actualizar la nota:", error);
      toastAlert("Error al actualizar la nota: " + error.message, "error");
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { updateNote, loading };
};